import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { FormSectionProps } from '../../interfaces/form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormField from '../../components/FormField'

const SickPay = ({ validate }: FormSectionProps) => {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 4 }}>
            How many weeks' full sick pay do you get from your employer?
          </Typography>
          <Grid container spacing={2} sx={{ mb: 16 }}>
            <Grid
              item
              xs={12}
              md={6}
              alignItems="center"
              sx={{ display: 'flex' }}
            >
              <Typography variant="body1">Full pay for</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              alignItems="center"
              sx={{ display: 'flex' }}
            >
              <FormField
                id="sickPayWeeks"
                name="sickPayWeeks"
                type="number"
                inputProps={{ type: 'number' }}
                InputProps={{
                  endAdornment: <span style={{ marginLeft: 10 }}>weeks</span>,
                }}
              />
            </Grid>
          </Grid>
          <Typography variant="body1" fontSize={16} sx={{ mb: 4 }}>
            Most people get 13-26 weeks' sick pay. If you're not sure how much
            you get, stick with the default of 13 weeks. &nbsp;
            <strong>If you don't get any sick pay, enter 0 weeks.</strong>
          </Typography>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default SickPay
